import React from 'react'

export default function ServiceIntegration() {
  return (
    <div>Service Integration</div>
  )
}
